import { fetch } from '@financial-tool/fetch';
import { RevenueData } from '../types/settings';

export default function getInvoicesSync() {
  return fetch.get<RevenueData>('/invoicing/sync');
}
